import React from "react";
import PropTypes from "prop-types";
import Style from "./modal.module.scss";
import { alertActions } from "../../locales/en";
import CommonModal from "./CommonModal";

export const SuccessfullModal = ({ isOpen, toggle, message, title }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="sm"
      modalClassName={`${Style.xeroModal} modal-dialog-centered`}
      bodyClassName="text-center"
      footerClassName={Style.aiScModalFooter}
      footerButtons={[
        {
          label: alertActions.ok,
          className: "btn btn-primary",
          onClick: toggle
        }
      ]}
    >
      <div className={`${Style.aiScModalContent} modal-content text-center`}>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
    </CommonModal>
  );
};
SuccessfullModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string
};
